const User = ({
  loggedIn = false,
  userToken = '',
  email = '',
  phoneNumber = '',
  hasStrongAuthentication = false,
  isEmailVerified = false,
  isTwoFactorAuthEnabled = false,
  isTwoFactorAuthenticated = false,
  roles = [],
  impersonatorUserToken = '',
  impersonatorEmail = '',
  isUserBlocked = false,
  sessionSecondsRemaining = 0,
} = {}) => {
  const userModel = {
    loggedIn: Boolean(loggedIn),
    userToken: String(userToken),
    email: String(email),
    phoneNumber: String(phoneNumber),
    isEmailVerified: Boolean(isEmailVerified),
    isTwoFactorAuthEnabled: Boolean(isTwoFactorAuthEnabled),
    isTwoFactorAuthenticated: Boolean(isTwoFactorAuthenticated),
    hasStrongAuthentication: Boolean(hasStrongAuthentication),
    roles: [].concat(roles),
    impersonatorUserToken: '',
    impersonatorEmail: '',
    isUserBlocked: Boolean(isUserBlocked),
    sessionExpirationDate: sessionSecondsRemaining ? Date.now() + sessionSecondsRemaining * 1000 : 0,
  };

  if (impersonatorUserToken) {
    userModel.impersonatorUserToken = String(impersonatorUserToken);
  } else {
    delete userModel.impersonatorUserToken;
  }

  if (impersonatorEmail) {
    userModel.impersonatorEmail = String(impersonatorEmail);
  } else {
    delete userModel.impersonatorEmail;
  }

  return userModel;
};

export default User;
